import React from "react";

const DateRangePicker = ({ startDate, endDate, onStartDateChange, onEndDateChange, onSearch, loading }) => {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-700">From:</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          className="px-3 py-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none text-sm"
        />
      </div>

      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-700">To:</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          className="px-3 py-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none text-sm"
        />
      </div>

      <button
        onClick={onSearch}
        disabled={loading}
        className={`flex items-center gap-2 px-6 py-2 rounded-full text-white font-semibold shadow-md transition duration-200 ${
          loading
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-indigo-600 hover:to-indigo-500"
        }`}
      >
        {loading ? (
          <>
            <i className="fas fa-spinner fa-spin"></i>
            Loading...
          </>
        ) : (
          <>
            <i className="fas fa-search"></i>
            Search
          </>
        )}
      </button>
    </div>
  );
};

export default DateRangePicker;
